module.exports = __webpack_public_path__ + "fonts/Golos-Text_Medium.978db9e.eot";